import * as gender from './gender'

export const staticOptionsHelper = {
  gender,
}
